import axios from '@axios'
import config from '@core/app-config/api-config'
import crudModule from './crud_module'

const entity = 'hash-tag/news'
const baseUrl = `${config.host}/${entity}`

const crud = crudModule({ entity_name: entity })

export default {
  getList(filterText) {
    const params = filterText ? { filterText: filterText.trim() } : undefined
    return crud.fetchItems(params)
  },

  create(name) {
    return crud.createItem({ name: name.trim() })
  },

  update(id, name) {
    return crud.updateItem(id, { name: name.trim() })
  },

  remove(id) {
    return crud.deleteItem(id)
  },

  merge(body) {
    return axios.post(`${baseUrl}/merge`, body)
  },

  mergeSimilar() {
    return axios.post(`${baseUrl}/merge-similar`)
  },
}
